module.exports = __webpack_public_path__ + "static/blackground_2.bd54a4c5.png";